import React from "react";
const ThemeManagerIDContext = React.createContext(1);
export { ThemeManagerIDContext };
//# sourceMappingURL=ThemeManagerContext.mjs.map
